document.addEventListener('DOMContentLoaded', function() {
  const moreBtn = document.querySelector('[data-reviews-more]');
  if (!moreBtn) return;

  const reviewsSection = moreBtn.closest('#reviews');
  if (!reviewsSection) return;

  moreBtn.addEventListener('click', function() {
    const total = parseInt(this.dataset.total);
    let visible = parseInt(this.dataset.visible);
    const step = parseInt(this.dataset.step);
    const newVisible = Math.min(visible + step, total);

    const items = reviewsSection.querySelectorAll('[data-review-index]');
    items.forEach(item => {
      const index = parseInt(item.dataset.reviewIndex);
      if (index <= newVisible) {
        item.classList.remove('rd-review-card_hidden');
      }
    });

    this.dataset.visible = newVisible;

    if (newVisible >= total) {
      this.style.display = 'none';
    }
  });
});
